import { NgModule } from 'ng-metadata/core';
import { FindComponent } from './find.component';

/**
 * @ngdoc module
 * @name mw.components.find
 * @description
 *
 * Search
 */
@NgModule({
  declarations: [ FindComponent ]
})

export class FindModule {}



// WEBPACK FOOTER //
// ./src/lib/components/find/find.module.ts